import { Component } from '@angular/core';

@Component({
  selector: 'sh-platform-action-ticker',
  templateUrl: './platform-action-ticker.component.html',
  styleUrl: './platform-action-ticker.component.scss',
  standalone: false
})
export class PlatformActionTickerComponent {
  readonly date = new Date();

  constructor() {}
}
